<script setup lang="ts">
/*
 * The footer's one line of facts: instant delivery · PDF receipt per top-up ·
 * live "{N} keys in stock". Only the stock number comes from the API
 * (`GET /products?limit=1` → `total`, in-stock listings); if the request
 * fails the clause is simply left out rather than guessed.
 */
import { FileText, KeyRound, Zap } from 'lucide-vue-next';
import { onMounted, ref } from 'vue';
import { api } from '../../api/client';
import type { Paged, ProductSummary } from '../../types/product';

const stock = ref<number | null>(null);

onMounted(async () => {
  try {
    const { data } = await api.get<Paged<ProductSummary>>('/products', { params: { limit: 1, inStockOnly: true } });
    stock.value = data.total;
  } catch {
    // facts line degrades to the two static clauses
  }
});
</script>

<template>
  <ul class="flex flex-wrap items-center gap-x-6 gap-y-2 text-[13px] text-text-dim">
    <li class="flex items-center gap-2"><Zap class="h-4 w-4 text-accent" aria-hidden="true" />{{ $t('footer.facts.instant') }}</li>
    <li class="flex items-center gap-2"><FileText class="h-4 w-4 text-accent" aria-hidden="true" />{{ $t('footer.facts.receipt') }}</li>
    <li v-if="stock !== null && stock > 0" class="flex items-center gap-2 tabular-nums">
      <KeyRound class="h-4 w-4 text-accent" aria-hidden="true" />{{ $t('footer.facts.stock', { count: stock.toLocaleString('en-US') }, stock) }}
    </li>
  </ul>
</template>
